import {
	Type,
	TypesApiResponse,
	typesApiResponseSchema,
	Requirement,
	requirementsSchema,
	typeSchema,
} from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getEventTypes = async (query?: string): Promise<TypesApiResponse> => {
	const { body } = await clientRequest.get(`/api/types/event?noPagination=true&${query ? `${query}` : ''}`, {
		schema: typesApiResponseSchema,
	});
	return body;
};

export const getAllEventTypes = async (query?: string): Promise<TypesApiResponse> => {
	const { body } = await clientRequest.get(`/api/types/event/all${query ? `?${query}` : ''}`, {
		schema: typesApiResponseSchema,
	});
	return body;
};
//
export const getGroupTypes = async (query?: string): Promise<TypesApiResponse> => {
	const { body } = await clientRequest.get(`/api/types/group?noPagination=true&${query ? `${query}` : ''}`, {
		schema: typesApiResponseSchema,
	});
	return body;
};

export const getAllGroupTypes = async (query?: string): Promise<TypesApiResponse> => {
	const { body } = await clientRequest.get(`/api/types/group/all${query ? `?${query}` : ''}`, {
		schema: typesApiResponseSchema,
	});
	return body;
};

export const getRequirements = async (): Promise<Requirement[]> => {
	try {
		const { body } = await clientRequest.get('/api/types/requirements', {
			schema: requirementsSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get requirements:', error);
		return [];
	}
};

export const getTypeForModel = async (model: string, id: string): Promise<Type> => {
	const { body } = await clientRequest.get(`/api/types/${model}/${id}`, { schema: typeSchema });
	return body;
};

export const getTypesForRole = async (roleId: string): Promise<Type[]> => {
	try {
		const { body } = await clientRequest.get<undefined, Type[]>(`/api/roles/${roleId}/types`, { schema: undefined });
		return body || [];
	} catch {
		return [];
	}
};

export const getAllTypes = async (): Promise<Type[]> => {
	try {
		const { body } = await clientRequest.get<undefined, Type[]>('/api/types?noPagination=true', {
			schema: undefined,
		});
		return body || [];
	} catch {
		return [];
	}
};
